"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _polished = require("polished");

// @import 'breakpoints';
// @import 'units';
var fontSansSerif = "'Guardian Sans', 'Helvetica Neue', Helvetica, sans-serif";
var fontTextSansSerif = "'Guardian Text Sans', 'Helvetica Neue', Helvetica, sans-serif"; // - FONT SIZES

var _default = {
  fontSizeBase: '16px',
  fontSizes: {
    h1: (0, _polished.rem)('40px'),
    h2: (0, _polished.rem)('32px'),
    h3: (0, _polished.rem)('28px'),
    h4: (0, _polished.rem)('24px'),
    h5: (0, _polished.rem)('20px'),
    h6: (0, _polished.rem)('16px')
  },
  fontSizesMedium: {
    h1: (0, _polished.rem)('34px'),
    h2: (0, _polished.rem)('28px'),
    h3: (0, _polished.rem)('24px'),
    h4: (0, _polished.rem)('20px'),
    h5: (0, _polished.rem)('18px'),
    h6: (0, _polished.rem)('16px')
  },
  fontSizesSmall: {
    h1: (0, _polished.rem)('28px'),
    h2: (0, _polished.rem)('24px'),
    h3: (0, _polished.rem)('20px'),
    h4: (0, _polished.rem)('18px'),
    h5: (0, _polished.rem)('16px'),
    h6: (0, _polished.rem)('14px')
  },
  // - LINE HEIGHTS
  fontLineHeightBase: (0, _polished.rem)('24px'),
  fontLineHeights: {
    h1: (0, _polished.rem)('48px'),
    h2: (0, _polished.rem)('40px'),
    h3: (0, _polished.rem)('36px'),
    h4: (0, _polished.rem)('32px'),
    h5: (0, _polished.rem)('28px'),
    h6: (0, _polished.rem)('24px')
  },
  fontLineHeightsMedium: {
    h1: (0, _polished.rem)('42px'),
    h2: (0, _polished.rem)('36px'),
    h3: (0, _polished.rem)('32px'),
    h4: (0, _polished.rem)('28px'),
    h5: (0, _polished.rem)('26px'),
    h6: (0, _polished.rem)('24px')
  },
  fontLineHeightsSmall: {
    h1: (0, _polished.rem)('36px'),
    h2: (0, _polished.rem)('32px'),
    h3: (0, _polished.rem)('28px'),
    h4: (0, _polished.rem)('26px'),
    h5: (0, _polished.rem)('24px'),
    h6: (0, _polished.rem)('22px')
  },
  // - LETTER SPACING
  fontLetterSpacingBase: 0,
  fontLetterSpacing: '1px',
  // - FONT WEIGHTS
  weightThin: 100,
  weightLight: 300,
  weightRegular: 400,
  weightMedium: 500,
  weightSemibold: 600,
  // - FONT FAMILIES
  fontSansSerif: fontSansSerif,
  fontTextSansSerif: fontTextSansSerif,
  fontFamilies: {
    h1: fontSansSerif,
    h2: fontSansSerif,
    h3: fontSansSerif,
    h4: fontSansSerif,
    h5: fontTextSansSerif,
    h6: fontTextSansSerif
  }
};
/*
// - FONT STACK
$font-family-sans-serif: 'Guardian Sans', 'Helvetica Neue', Helvetica, sans-serif;
$font-family-text-sans-serif: 'Guardian Text Sans', 'Helvetica Neue', Helvetica, sans-serif;

$font-families: (
  h1: $font-family-sans-serif,
  h2: $font-family-sans-serif,
  h3: $font-family-sans-serif,
  h4: $font-family-sans-serif,
  h5: $font-family-text-sans-serif,
  h6: $font-family-text-sans-serif
);

// - FONT IMPORTS
$guardian-sans-thin: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Thin',
  style: normal,
  weight: $weight-thin
);

$guardian-sans-thin-italic: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Thin-Italic',
  style: italic,
  weight: $weight-thin
);

$guardian-sans-light: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Light',
  style: normal,
  weight: $weight-light
);

$guardian-sans-light-italic: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Light-Italic',
  style: italic,
  weight: $weight-light
);

$guardian-sans-regular: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Regular',
  style: normal,
  weight: $weight-regular
);

$guardian-sans-regular-italic: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Regular-Italic',
  style: italic,
  weight: $weight-regular
);

$guardian-sans-medium: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Medium',
  style: normal,
  weight: $weight-medium
);

$guardian-sans-medium-italic: (
  name: 'Guardian Sans',
  file: 'GuardianSans-Medium-Italic',
  style: italic,
  weight: $weight-medium
);

$guardian-sans-semibold: (
  name: 'Guardian Sans',
  file: 'GuardianSans-SemiBold',
  style: normal,
  weight: $weight-semibold
);

$guardian-sans-semibold-italic: (
  name: 'Guardian Sans',
  file: 'GuardianSans-SemiBold-Italic',
  style: italic,
  weight: $weight-semibold
);

$guardian-text-sans-regular: (
  name: 'Guardian Text Sans',
  file: 'GuardianTextSans-Regular-Web',
  style: normal,
  weight: $weight-regular
);

$guardian-text-sans-medium: (
  name: 'Guardian Text Sans',
  file: 'GuardianTextSans-Medium-Web',
  style: normal,
  weight: $weight-medium
);

//
// FONT LIST
// Each font object declared above is passed into $font-list below.
//
$font-list: (
  $guardian-sans-thin-italic,
  $guardian-sans-thin,
  $guardian-sans-light-italic,
  $guardian-sans-light,
  $guardian-sans-regular-italic,
  $guardian-sans-regular,
  $guardian-sans-medium-italic,
  $guardian-sans-medium,
  $guardian-sans-semibold,
  $guardian-sans-semibold-italic,
  $guardian-text-sans-regular,
  $guardian-text-sans-medium
);

@mixin font-face($font) {
  $font-path: 'https://plan.northwesternmutual.com/static/assets/public/fonts';
  $exts: 'woff2', 'woff';
  $name: map-get($font, 'name');
  $weight: map-get($font, 'weight');
  $file: map-get($font, 'file');
  $style: map-get($font, 'style');
  $src: null;
  $path: $font-path + '/' + $file;

  @each $ext in $exts {
    $src: append($src, url(quote($path + '.' + $ext)) format(quote($ext)), comma);
  }

  @font-face {
    font-family: quote($name);
    font-style: $style;
    font-weight: $weight;
    src: $src;
  }
}

/// @example scss
///   h1 { @include font-header(h1); }
@mixin font-header($header) {
  font-family: map-get($font-families, $header);
  font-size: map-get($font-sizes-small, $header);
  font-weight: $weight-medium;
  letter-spacing: $font-letter-spacing;
  line-height: map-get($font-line-heights-small, $header);

  @include breakpoint(medium) {
    font-size: map-get($font-sizes-medium, $header);
    line-height: map-get($font-line-heights-medium, $header);
  }
  @include breakpoint(large) {
    font-size: map-get($font-sizes, $header);
    line-height: map-get($font-line-heights, $header);
  }
}

/// @example scss
///   .cell { @include font-tf; }
@mixin font-tf {
  font-family: $font-family-text-sans-serif;
  font-feature-settings: 'tnum';
}
*/

exports.default = _default;
//# sourceMappingURL=fonts.js.map